import Help from '../components/Help/Help';

const HelpPage = () => <Help />;

export default HelpPage;
